<template>
  <div>
    <div v-if="window.size.desktop" class="fixed w-full h-full top-0 left-0 rounded-md z-backdrop bg-black/40" @click.stop="closeModal(selectedOption)"></div>
    <div v-if="window.size.mobile" class="z-backdrop fixed left-0 top-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto !bg-black/40">
      <div v-click-outside="clickOutside" class="mx-auto fixed modal-mobile overflow-hidden w-full cursor-pointer bg-zt-normal custom-modal rounded-md zt-shadow text-left text-[16px]">
        <div class="relative py-4 px-5 border-b border-[#313A44] flex flex-nowrap justify-start items-center">
          <span class="font-semibold">Filtruj Gale</span>
          <div class="x-close-modal" @click="closeModal(selectedOption)"></div>
        </div>
        <div class="w-full relative py-3 border-b border-[#313A44] font-medium hover:bg-[#313E50]" 
             :class="[selectedOption === 1 ? ['bg-[#313E50] before:bg-zt-red'] : '']" @click.stop="closeModal(1)">
          <span class="mx-3">Wszystkie</span>
        </div>
        <div class="w-full relative py-3 border-b border-[#313A44] font-medium hover:bg-[#313E50]" 
             :class="[selectedOption === 2 ? ['bg-[#313E50] before:bg-zt-red'] : '']" @click.stop="closeModal(2)">
          <span class="mx-3">Z naszą relacją</span>
        </div>
        <div class="w-full relative py-3 border-b border-[#313A44] font-medium hover:bg-[#313E50]" 
             :class="[selectedOption === 3 ? ['bg-[#313E50] before:bg-zt-red'] : '']" @click.stop="closeModal(3)">
          <span class="mx-3">Freak fight</span>
        </div>
        <div class="w-full relative py-3 border-b border-[#313A44] font-medium hover:bg-[#313E50]" 
             :class="[selectedOption === 4 ? ['bg-[#313E50] before:bg-zt-red'] : '']" @click.stop="closeModal(4)">
          <span class="mx-3">Na gołe pięści</span>
        </div>
        <div class="w-full relative py-3 font-medium hover:bg-[#313E50]" 
             :class="[selectedOption === 5 ? ['bg-[#313E50] before:bg-zt-red'] : '']" @click.stop="closeModal(5)">
          <span class="mx-3">Piłkarskie</span>
        </div>
      </div>
    </div>
    <div v-else-if="window.size.desktop" v-click-outside="clickOutside" 
         class="absolute z-modal w-[260px] -right-1.5 top-10 cursor-pointer bg-zt-normal custom-modal rounded-md zt-shadow text-left font-medium text-[16px]" 
         style="box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25)">
      <div class="w-full relative rounded-t-zt py-3 border-b border-[#313A44] hover:bg-[#313E50]" 
           :class="[selectedOption === 1 ? ['bg-[#313E50] before:bg-zt-red'] : '']" @click.stop="closeModal(1)">
        <span class="mx-3">Wszystkie</span>
      </div>
      <div class="w-full relative border-b border-[#313A44] py-3 hover:bg-[#313E50]" 
           :class="[selectedOption === 2 ? ['bg-[#313E50] before:bg-zt-red'] : '']" @click.stop="closeModal(2)">
        <span class="mx-3">Z naszą relacją</span>
      </div>
      <div class="w-full relative border-b border-[#313A44] py-3 hover:bg-[#313E50]" 
           :class="[selectedOption === 3 ? ['bg-[#313E50] before:bg-zt-red'] : '']" @click.stop="closeModal(3)">
        <span class="mx-3">Freak fight</span>
      </div>
      <div class="w-full relative border-b border-[#313A44] py-3 hover:bg-[#313E50]" 
           :class="[selectedOption === 4 ? ['bg-[#313E50] before:bg-zt-red'] : '']" @click.stop="closeModal(4)">
        <span class="mx-3">Na gołe pięści</span>
      </div>
      <div class="w-full relative rounded-b-zt py-3 hover:bg-[#313E50]" 
           :class="[selectedOption === 5 ? ['bg-[#313E50] before:bg-zt-red'] : '']" @click.stop="closeModal(5)">
        <span class="mx-3">Piłkarskie</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SelectRelationPlannedModal',
  emits: ['close-modal'],
  props: {
    selectedOption: Number
  },
  data() {
    return {
      clickOutside: {
        handler: () => {
          this.$emit('close-modal', this.selectedOption);
        },
        events: ['touchend', 'mouseup']
      }
    };
  },
  methods: {
    closeModal(option) {
      this.$emit('close-modal', option);
    },
  }
};
</script>

<style scoped>
.custom-modal:after {
  @apply content-[''] absolute -top-4 right-5 w-0 h-0 border-b-zt-normal border-b-[16px] border-x-transparent border-x-[8px];
}
.custom-modal div:before {
  @apply content-[''] w-[3px] top-[10%] left-0 h-[80%] rounded-zt absolute;
}
</style>